import { render, staticRenderFns } from "./node-cbox.vue?vue&type=template&id=57f8c95e&scoped=true&"
import script from "./node-cbox.vue?vue&type=script&lang=js&"
export * from "./node-cbox.vue?vue&type=script&lang=js&"
import style0 from "./node-cbox.vue?vue&type=style&index=0&id=57f8c95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8c95e",
  null
  
)

export default component.exports